'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


//////////////////
// WEBPACK FOOTER
// ./~/_history@2.1.2@history/lib/ExecutionEnvironment.js
// module id = 243
// module chunks = 0